<template>
  <v-row>
    <page-container
      primary
      :title="$t('services.categories.neuromarketing.packaging.title')"
      intro=""
      :breadcrumbs="breadcrumbs"
    >
      Coming soon
    </page-container>
  </v-row>
</template>

<script>
import PageContainer from '@/components/PageContainer'

export default {
  components: {
    PageContainer
  },
  async asyncData({ app }) {
    return {
      breadcrumbs: [
        {
          text: app.i18n.t('nav.services'),
          disabled: false,
          to: app.localePath('services'),
        },
        {
          text: app.i18n.t('services.categories.neuromarketing.title'),
          disabled: true,
          href: ''
        },
        {
          text: app.i18n.t('services.categories.neuromarketing.packaging.title'),
          disabled: true,
          href: ''
        }
      ]
    }
  }
}
</script>
